// GoLiveDonationModal.js
import React, { useState } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import nextarrow from "../assets/images/icons/next-arrow.svg";
import Dropdown from "../assets/images/icons/arrow-down.svg";
import calendar from "../assets/images/icons/calendar.svg";
const GoLiveDonationModal = ({
  isOpen,
  onClose,
  logo,
  closeIcon,
  categories = [],
  initialData = null, // ✅ Add this
  onSave = null, // ✅ Add this
}) => {
  const [currency, setCurrency] = useState("");
  const [category, setCategory] = useState("");

  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: "",
    category: "",
    description: "",
    goalAmount: "",

    currency: "",
    bankName: "",
    ifsc: "",
    beneficiaryName: "",
    accountNumber: "",
  });

  // ✅ Pre-fill form if initialData is provided
  React.useEffect(() => {
    if (isOpen && initialData) {
      setFormData((prev) => ({
        ...prev,
        ...initialData,
      }));
    }
  }, [isOpen, initialData]);
  const [errors, setErrors] = useState({});
  if (!isOpen) return null;

  // Custom Styles for React Select
  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "48px", // Match the h-12 (48px) of other inputs
      borderRadius: "12px", // Match rounded-xl
      border: "1px solid #095228", // Match border color
      padding: "2px",
      boxShadow: "none",
      "&:hover": {
        border: "1px solid #095228",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#095228" : "white",
      color: state.isSelected ? "white" : "black",
      "&:hover": {
        backgroundColor: "#E8F5E9",
        color: "black",
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#9CA3AF", // gray-400
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  // Safe fallback for categories
  const categoryList =
    categories && categories.length > 0
      ? categories
      : [
          { id: "gaming", name: "Gaming" },
          { id: "education", name: "Education" },
        ];

  const categoryOptions = categoryList.map((cat) => ({
    value: cat.id || cat._id || cat.name, // fallback to name if id missing
    label: cat.name || cat.title || cat.category_name,
  }));

  // Helper to update state
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // --- 2. Validation & Redirection ---
  const handleNext = (e) => {
    e.preventDefault();
    let newErrors = {};

    // Define which fields are required
    const requiredFields = [
      "title",
      "category",
      "goalAmount",

      "currency",
      "accountNumber",
      "bankName",
      "ifsc",
      "beneficiaryName",
    ];

    // Check each field
    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field].toString().trim() === "") {
        if (field === "currency") {
          newErrors[field] = "Enter Default Currency";
        } else if (field === "bankName") {
          newErrors[field] = "Enter Bank Name";
        } else if (field === "ifsc") {
          newErrors[field] = "Enter Code";
        } else if (field === "beneficiaryName") {
          newErrors[field] = "Enter Name";
        } else if (field === "accountNumber") {
          newErrors[field] = "Enter Account Number";
        } else {
          newErrors[field] = "This field is required";
        }
      }
    });

    // If there are errors, update state and stop
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Clear errors and navigate if successful
    setErrors({});
    if (onSave) {
      onSave(formData);
      onClose();
    } else {
      navigate("/golivedonation", { state: formData });
    }
  };

  return (
    <div>
      <div className=" get-verified popup-share fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-60 w-full backdrop-blur-md">
        <div className="border-popup bg-white rounded-lg  relative">
          <div className="flex justify-between">
            <div className="logo-popup flex items-center justify-center space-x-2 ">
              <img src={logo} alt="Pipaan Logo" className="w-50" />
            </div>
            {/* Close Button */}
            <button onClick={onClose}>
              <img src={closeIcon} alt="close" className="w-8 h-8" />
            </button>
          </div>
          <div className="border-t-[#D9D9D9] border-t-2">
            <form onSubmit={handleNext} className="p-8 space-y-10">
              {/* Fund Information Section */}
              <div className="space-y-6">
                <h2 className="text-lg font-semibold text-[#095228]">
                  Fund Information
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium mb-2">
                      Title
                    </label>
                    <input
                      type="text"
                      name="title"
                      value={formData.title}
                      onChange={handleChange}
                      placeholder="Enter title"
                      className="w-full h-12 px-4 rounded-xl border border-[#095228] focus:outline-none"
                    />
                    {errors.title && (
                      <p className="text-red-500 text-xs mt-1 ml-1">
                        {errors.title}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">
                      Category
                    </label>
                    <div className="relative">
                      <select
                        name="category"
                        value={formData.category}
                        onChange={handleChange}
                        className={`w-full h-12 px-4 rounded-xl border border-[#095228] appearance-none ${
                          formData.category === ""
                            ? "text-gray-400"
                            : "text-black"
                        }`}
                      >
                        <option value="" disabled hidden>
                          Select Category
                        </option>
                        {categories && categories.length > 0 ? (
                          categories.map((cat) => (
                            <option
                              key={cat.id || cat._id}
                              value={cat.id || cat._id}
                            >
                              {cat.name || cat.title || cat.category_name}
                            </option>
                          ))
                        ) : (
                          <>
                            <option value="gaming">Gaming</option>
                            <option value="education">Education</option>
                          </>
                        )}
                      </select>
                      <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
                        <img src={Dropdown} alt="" className="w-4 h-4" />
                      </div>
                    </div>
                    {/* Show error message below the relative wrapper */}
                    {errors.category && (
                      <p className="text-red-500 text-xs mt-1 ml-1">
                        {errors.category}
                      </p>
                    )}
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">
                    Description
                  </label>
                  <textarea
                    name="description"
                    rows="3"
                    value={formData.description}
                    onChange={handleChange}
                    placeholder="Enter Description"
                    className="w-full px-4 py-3 rounded-xl border border-[#095228] resize-none focus:outline-none"
                  />
                  {errors.description && (
                    <p className="text-red-500 text-xs mt-1 ml-1">
                      {errors.description}
                    </p>
                  )}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
                  <div>
                    <label className="block text-sm font-medium mb-2">
                      Goal Amount
                    </label>
                    <div className="flex items-center border border-[#095228] rounded-xl h-12 px-3">
                      <span className="mr-2 text-gray-500">$</span>
                      <input
                        type="number"
                        name="goalAmount"
                        value={formData.goalAmount}
                        onChange={handleChange}
                        placeholder="0"
                        className="w-full focus:outline-none"
                      />
                    </div>
                    {errors.goalAmount && (
                      <p className="text-red-500 text-xs mt-1 ml-1">
                        {errors.goalAmount}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              {/* Bank Details Section */}
              <div className="space-y-6">
                <h2 className="text-lg font-semibold text-[#095228]">
                  Bank Account Details
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div>
                    <label className="block text-sm font-medium mb-2">
                      Default Currency
                    </label>
                    <div className="relative">
                      <select
                        name="currency"
                        value={formData.currency}
                        onChange={handleChange}
                        className={`w-full h-12 px-4 rounded-xl border border-[#095228] appearance-none ${
                          formData.currency === ""
                            ? "text-gray-400"
                            : "text-black"
                        }`}
                      >
                        <option value="" disabled hidden>
                          Enter Default Currency
                        </option>
                        <option value="USD">USD - US Dollar</option>
                      </select>
                      <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
                        <img src={Dropdown} alt="" className="w-4 h-4" />
                      </div>
                    </div>
                    {/* Show error message below the relative wrapper */}
                    {errors.currency && (
                      <p className="text-red-500 text-xs mt-1 ml-1">
                        {errors.currency}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">
                      Bank Name
                    </label>
                    <input
                      type="text"
                      name="bankName"
                      value={formData.bankName}
                      onChange={handleChange}
                      placeholder="Enter Bank Name"
                      className="w-full h-12 px-4 rounded-xl border border-[#095228] focus:outline-none"
                    />
                    {errors.bankName && (
                      <p className="text-red-500 text-xs mt-1 ml-1">
                        {errors.bankName}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">
                      IFSC or SWIFT
                    </label>
                    <input
                      type="text"
                      name="ifsc"
                      value={formData.ifsc}
                      onChange={handleChange}
                      placeholder="Enter Code"
                      className="w-full h-12 px-4 rounded-xl border border-[#095228] focus:outline-none"
                    />
                    {errors.ifsc && (
                      <p className="text-red-500 text-xs mt-1 ml-1">
                        {errors.ifsc}
                      </p>
                    )}
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-end">
                  <div>
                    <label className="block text-sm font-medium mb-2">
                      Beneficiary Name
                    </label>
                    <input
                      type="text"
                      name="beneficiaryName"
                      value={formData.beneficiaryName}
                      onChange={handleChange}
                      placeholder="Enter Name"
                      className="w-full h-12 px-4 rounded-xl border border-[#095228] focus:outline-none"
                    />
                    {errors.beneficiaryName && (
                      <p className="text-red-500 text-xs mt-1 ml-1">
                        {errors.beneficiaryName}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">
                      Account Number
                    </label>
                    <input
                      type="text"
                      name="accountNumber"
                      value={formData.accountNumber}
                      onChange={handleChange}
                      placeholder="Enter Account Number"
                      className="w-full h-12 px-4 rounded-xl border border-[#095228] focus:outline-none"
                    />
                    {errors.accountNumber && (
                      <p className="text-red-500 text-xs mt-1 ml-1">
                        {errors.accountNumber}
                      </p>
                    )}
                  </div>
                  <div className="flex justify-end">
                    <button
                      type="submit" // Changed to type submit
                      className="flex items-center gap-2 bg-[#095228] text-white px-8 h-12 rounded-full hover:bg-green-900 transition"
                    >
                      {onSave ? "Save" : "Next"}
                      <img src={nextarrow} className="ml-5" alt="next" />
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoLiveDonationModal;
